import reduce from 'mn-utils/reduce';

function flags(list, value, output) {
  return reduce(list, (output, name) => {
    output[name] = value;
    return output;
  }, output || {});
}

export const PERMISSION_DASHBOARD = 'dashboard';
export const PERMISSION_CURRENCY_TREND_CHART = 'currency_trend_chart';
export const PERMISSION_SALES_OVERVIEW = 'sales_overview';
export const PERMISSION_PAYOUT_HISTORY = 'payout_history';
export const PERMISSION_WITHDRAW = 'withdraw';
export const PERMISSION_NOTIFICATION_SETTINGS = 'notification_settings';
export const PERMISSION_ACCESS_PERMISSIONS = 'access_permissions';
export const PERMISSION_EDIT_BANK_DETAILS = 'edit_bank_details';
export const PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE = 'settlement_and_refund_preference';
export const PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS = 'order_terminal_and_terminal_details';
export const PERMISSION_CHANGE_AML_PREFERENCE = 'change_aml_preference';
export const PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS = 'setup_promotions_and_discounts';

export const ALL_PERMISSIONS = [
  PERMISSION_DASHBOARD,
  PERMISSION_CURRENCY_TREND_CHART,
  PERMISSION_SALES_OVERVIEW,
  PERMISSION_PAYOUT_HISTORY,
  PERMISSION_WITHDRAW,
  PERMISSION_NOTIFICATION_SETTINGS,
  PERMISSION_ACCESS_PERMISSIONS,
  PERMISSION_EDIT_BANK_DETAILS,
  PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  PERMISSION_CHANGE_AML_PREFERENCE,
  PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
];
export const PERMISSIONS_DISABLED = flags(ALL_PERMISSIONS, false);
export const PERMISSIONS_DEFAULT = flags([
  PERMISSION_DASHBOARD,
], true, {...PERMISSIONS_DISABLED});
export const PERMISSIONS_ADMIN = flags(ALL_PERMISSIONS, true);
export const PERMISSIONS_SALES = flags([
  PERMISSION_DASHBOARD,
  PERMISSION_CURRENCY_TREND_CHART,
  PERMISSION_SALES_OVERVIEW,
  // PERMISSION_PAYOUT_HISTORY,
  // PERMISSION_WITHDRAW,
  // PERMISSION_NOTIFICATION_SETTINGS,
  // PERMISSION_ACCESS_PERMISSIONS,

  // PERMISSION_EDIT_BANK_DETAILS,
  // PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  // PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  // PERMISSION_CHANGE_AML_PREFERENCE,
  // PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
], true, {...PERMISSIONS_DEFAULT});
export const PERMISSIONS_FINANCE = flags([
  PERMISSION_DASHBOARD,
  PERMISSION_CURRENCY_TREND_CHART,
  PERMISSION_SALES_OVERVIEW,
  PERMISSION_PAYOUT_HISTORY,
  PERMISSION_WITHDRAW,
  // PERMISSION_NOTIFICATION_SETTINGS,
  // PERMISSION_ACCESS_PERMISSIONS,
  // PERMISSION_EDIT_BANK_DETAILS,
  // PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  // PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  // PERMISSION_CHANGE_AML_PREFERENCE,
  // PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
], true, {...PERMISSIONS_DEFAULT});
export const PERMISSIONS_BUSINESS = flags([
  PERMISSION_DASHBOARD,
  // PERMISSION_CURRENCY_TREND_CHART,
  // PERMISSION_SALES_OVERVIEW,
  PERMISSION_PAYOUT_HISTORY,
  PERMISSION_WITHDRAW,
  // PERMISSION_NOTIFICATION_SETTINGS,
  // PERMISSION_ACCESS_PERMISSIONS,
  // PERMISSION_EDIT_BANK_DETAILS,
  // PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  // PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  // PERMISSION_CHANGE_AML_PREFERENCE,
  // PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
], true, {...PERMISSIONS_DEFAULT});
export const PERMISSIONS_CUSTOMER = flags([
  // PERMISSION_DASHBOARD,
  // PERMISSION_CURRENCY_TREND_CHART,
  // PERMISSION_SALES_OVERVIEW,
  PERMISSION_PAYOUT_HISTORY,
  // PERMISSION_WITHDRAW,
  // PERMISSION_NOTIFICATION_SETTINGS,
  // PERMISSION_ACCESS_PERMISSIONS,
  // PERMISSION_EDIT_BANK_DETAILS,
  // PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  // PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  // PERMISSION_CHANGE_AML_PREFERENCE,
  // PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
], true, {...PERMISSIONS_DEFAULT});
